import { useEffect, useState } from "react";
import { Pie } from "react-chartjs-2";
import {
  Chart as ChartJS,
  ArcElement, // Import ArcElement for pie/doughnut charts
  Tooltip,
  Legend,
  TooltipItem,
  ChartData,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { useSelector } from "react-redux";
import RootState from "../../../../redux/type";
import { RazorNumberFormat } from "../../../../components/razor-reuse";
import { approximateToNearestWholeNumber } from "../../../../utils/Helper";

// Register required components
ChartJS.register(ArcElement, Tooltip, Legend, ChartDataLabels);

const data = {
  labels: ["Successful Transactions", "Failed Transactions"], // Labels for the pie slices
  datasets: [
    {
      label: "Dataset",
      data: [60, 40], // Values for each slice
      backgroundColor: ["rgba(17, 156, 43, 0.7)", "rgba(236, 20, 16, 0.7)"], // Colors for slices
      borderColor: ["rgba(17, 156, 43, 0.7)", "rgba(236, 20, 16, 0.7)"], // Border colors
      borderWidth: 1, // Width of the slice borders
    },
  ],
};

// Define options
const options = {
  responsive: true,
  plugins: {
    legend: {
      display: false,
      position: "bottom", // Position of the legend
    },
    tooltip: {
      enabled: false, // Enable tooltips
      callbacks: {
        // @ts-ignore
        label: function (
          // @ts-ignore
          tooltipItem: TooltipItem<MyChartType>,
          data: ChartData | undefined
        ) {
          if (
            !data ||
            !data.datasets ||
            !data.datasets[tooltipItem.datasetIndex]
          ) {
            // @ts-ignore
            return `${RazorNumberFormat(tooltipItem.raw, {
              //   hideDecimal: true,
              hideSymbol: true,
            })}%`; // If no data, return the raw value as string
          }
        },
      },
    },
    datalabels: {
      display: true, // Enable data labels for this chart
      color: "#fff", // Set text color
      formatter: (value: number) => `${value}%`, // Format the value
      font: {
        weight: "bold",
        size: "20rem",
      },
    },
  },
};

interface MyComponentProps {
  datatoShow?: any;
  activeTab?: string;
}

const PieChartFragment = () => {
  const [datatoSHow, setDataToShow] = useState<any>({
    labels: ["Successful Transactions", "Failed Transactions"], // Labels for the pie slices
    datasets: [
      {
        label: "",
        data: [0, 0], // Values for each slice
        backgroundColor: ["rgba(17, 156, 43, 0.7)", "rgba(236, 20, 16, 0.7)"], // Colors for slices
        borderColor: ["rgba(17, 156, 43, 0.7)", "rgba(236, 20, 16, 0.7)"], // Border colors
        borderWidth: 1, // Width of the slice borders
      },
    ],
  });
  const { transaction_metric } = useSelector(
    (state: RootState) => state.dashboard
  );

  useEffect(() => {
    if (Object?.keys(transaction_metric)?.length > 0) {
      const val = {
        labels: [
          "Successful Transactions",
          "Failed Transactions",
          "Pending Transactions",
        ], // Labels for the pie slices
        datasets: [
          {
            label: "Dataset",
            data: [
              //   Number(
              approximateToNearestWholeNumber(
                transaction_metric?.total_volume_insight[0]
                  ?.percentage_successful
              ),
              //   Number(
              approximateToNearestWholeNumber(
                transaction_metric?.total_volume_insight[0]?.percentage_failed
              ),
            ], // Values for each slice
            backgroundColor: [
              "rgba(17, 156, 43, 0.7)",
              "rgba(236, 20, 16, 0.7)",
              "#FFC043",
            ], // Colors for slices
            borderColor: [
              "rgba(17, 156, 43, 0.7)",
              "rgba(236, 20, 16, 0.7)",
              "#FFC043",
            ], // Border colors
            borderWidth: 1, // Width of the slice borders
          },
        ],
      };
      setDataToShow(val);
    }
  }, [transaction_metric]);

  return (
    <Pie data={datatoSHow} options={options as any} height={100} width={100} />
  );
};

export default PieChartFragment;
